export const CHECKOUT_URL =
  'https://special-education-teacher-pro.impultienda.ar/checkout'

export const BUY_ANCHOR = 'buy'

export const PRODUCT_NAME = 'SPECIAL EDUCATION TEACHER PRO™'

export const CTA_LABEL = 'GET SPECIAL EDUCATION TEACHER PRO™ NOW'

export function scrollToBuy(): void {
  const el = document.getElementById(BUY_ANCHOR)
  if (el) {
    el.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    })
  }
}

export const IMAGES = {
  boxSet:
    'https://cdn.magicpatterns.com/uploads/eyBnQM98FRuexFY3ucDirw/Diseno_sin_titulo-3.png',
}
